import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useIdentity } from '@zenbusiness/application-commons-identity';
import { useError } from '@zenbusiness/application-commons-logging';

export const GET_BUSINESS_ENTITIES = gql`
  query BusinessEntitiesQuery($filter: BusinessEntitiesFilter) {
    businessEntities(filter: $filter) {
      edges {
        node {
          uuid
          name
        }
      }
    }
  }
`;

export function useBusinessEntities() {
  const { accountUuid } = useIdentity();

  const { loading, data, error } = useQuery(GET_BUSINESS_ENTITIES, {
    noThrow: true,
    variables: {
      filter: { accountUuid },
    },
  });

  useError(error);

  const result = data?.businessEntities?.edges.map(({ node }) => ({
    uuid: node.uuid,
    name: node.name,
  }));

  return {
    loading,
    businessEntities: result || [],
  };
}
